/**
 * 计量处罚 - 首页汇总卡片
 */
import React from 'react';
import { Button } from '@tencent/spaui';
import { hooks } from '@tencent/ptp-fe-common';
import Icon from '@tencent/od-icon';
import dayjs from 'dayjs';
import PlainTable from '@/common-components/table/PlainTable';
import globalStore from '@/stores';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import SummaryStats from '../components/SummaryStats';
import { getAgencyEventList } from '../api';
import { EVENT_STATUS } from '../config';

const { useFetch } = hooks;

const columns = [
  {
    name: 'event_name',
    title: '事件名称',
    minWidth: 140,
  },
  {
    name: 'light_on_time',
    title: '亮灯时间',
    minWidth: 135,
    render: (type: string, _name: string, value: any) => {
      if (type === 'data') {
        return value ? dayjs(value).format('YYYY-MM-DD') : '-';
      }
    },
  },
  {
    name: 'event_info',
    title: '事件信息',
    minWidth: 200,
    render: (type: string, _name: string, value: any) => {
      if (type === 'data') {
        return (
          <div className="tw-whitespace-normal tw-break-words tw-leading-normal">
            {value || '-'}
          </div>
        );
      }
    },
  },
  {
    name: 'status',
    title: '事件状态',
    minWidth: 80,
    maxWidth: 80,
    render: (type: string, _name: string, value: any) => {
      if (type === 'data') {
        const label = EVENT_STATUS.getDescByValue(value) || '-';
        if (value === EVENT_STATUS.upgradedUnhandled) {
          return <span className="tw-text-red-500 tw-font-medium">{label}</span>;
        }
        return <span>{label}</span>;
      }
    },
  },
  {
    name: 'operation',
    title: '操作',
    minWidth: 60,
    maxWidth: 60,
    render: (type: string, _name: string, _value: any, data: any) => {
      if (type === 'data') {
        const isHandled = data.status === EVENT_STATUS.handled;
        return (
          <Button
            displayType="link"
            size="small"
            onClick={() => window.open(`${REACT_APP_PUBLIC_URL}/agency/task-center/event/detail?id=${data.id}`)}
          >
            {isHandled ? '详情' : '处理'}
          </Button>
        );
      }
    },
  },
];

const IllegalEventHomeCard: React.FC = () => {
  /** 最新 5 条事件（待处理状态） */
  const { data: latestList, fetching: latestLoading } = useFetch(
    getAgencyEventList,
    {
      page: 1,
      page_size: 5,
      status_list: [EVENT_STATUS.unhandled, EVENT_STATUS.upgradedUnhandled],
      is_home: true,
    },
    [],
    true,
    undefined,
    (res: any) => res?.data?.list || [],
  );

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-[16px]">
        <div className="tw-text-[18px] tw-font-semibold tw-text-gray-800">事件</div>
        <Button
          displayType="text"
          endIcon={<Icon name="right-outlined" />}
          onClick={() => globalStore.history.push('/agency/task-center/event/list')}
        >
          全部
        </Button>
      </div>

      <SummaryStats isHome={true} />

      <PlainTable
        data={latestList || []}
        columns={columns}
        loading={latestLoading}
        maxHeight={360}
        wordWrap={false}
        className="tw-mt-[16px]"
      />
    </div>
  );
};

export default IllegalEventHomeCard;
